import { ContentLayout } from 'components/Layout';
import { useAuth } from 'lib/auth';
import { Head } from 'components/Head';
import { InitialDepositRequired } from '../components/InitialDepositRequired';

export const Dashboard = () => {
  const { user } = useAuth();

  return (
    <ContentLayout>
      <Head title="Home" />
      {user.status === 'INACTIVE' && (
        <div className="mx-auto md:w-1/2">
          <>Hey {user.firstName},</>
          <InitialDepositRequired />
        </div>
      )}
      {user.status === 'ACTIVE' && (
        <>
          <div className="">With Love Uganda System Currently in development</div>
        </>
      )}
    </ContentLayout>
  );
};
